// extracted by mini-css-extract-plugin
export default {"root":"Price_root__1a9im","compareAtPrice":"Price_compareAtPrice__2qjY4","marginal":"Price_marginal__3Cjmx","flip":"Price_flip__wjo7_"};